import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationItem, SidePanelV3 } from '@gea/digital-ui-lib';
import { Subject } from 'rxjs';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AppInitService } from './pages/core/shared/services/app-init.service';
import { SpinnerService } from './pages/core/shared/services/spinner.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'PIDDiagramGenius';
  navItems: NavigationItem[] = [];

  adminNavItems: NavigationItem[] = [];
  botItems: SidePanelV3[] = [];

  /** null = comprobando, true = acceso concedido, false = acceso denegado */
  hasAccess: boolean | null = environment.name.includes('cloud') ? null : true;

  constructor(
    private appInitService: AppInitService,
    public spinnerService: SpinnerService,
    public translate: TranslateService,
  ) {
    translate.addLangs(['en-US', 'es-ES']);
    translate.setDefaultLang('en-US');
    var browserLang = translate.getBrowserLang();
    translate.use(browserLang?.match(/en-US|es-ES/) ? browserLang : 'en-US');
  }

  ngOnInit() {
    console.log('Environment Name:', environment.name);
    if (environment.name.includes('cloud')) {
      console.log('Initializing app in cloud environment');
      this.appInitService.init();
      this.appInitService.hasAccess$.subscribe(value => {
        if (value !== null) {
          this.hasAccess = value;
        }
      });
    }

    this.navItems.push({
      label: 'UI-LIB.SIDE-BAR.Home',
      route: '/',
      icon: 'apps',
    });
  }

}
